export default function Certifications() {
  return (
    <div className="bg-gradient-to-br from-blue-50 to-green-50 rounded-2xl p-8">
      <h2 className="text-3xl font-bold text-gray-900 mb-6 text-center">
        Certifications & Credentials
      </h2>
      <p className="text-center text-gray-600 mb-8 max-w-2xl mx-auto">
        We are proud to be officially registered and certified by leading financial regulatory bodies in India, 
        ensuring you receive professional and compliant financial advisory services.
      </p>
      
      <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
        {/* AMFI Certification */}
        <div className="bg-white rounded-xl shadow-lg p-6 text-center border-2 border-blue-100 hover:border-blue-300 transition-all">
          {/* AMFI Logo */}
          <div className="flex justify-center mb-4">
            <div className="bg-gradient-to-br from-green-50 to-blue-50 rounded-lg p-4 border-2 border-blue-200">
              <img 
                src="/amfi-logo.png" 
                alt="AMFI Logo" 
                className="h-24 w-24 mx-auto object-contain"
                onError={(e) => {
                  // Fallback SVG if logo image not found
                  const target = e.currentTarget as HTMLImageElement;
                  target.style.display = 'none';
                  const parent = target.parentElement;
                  if (parent && !parent.querySelector('svg')) {
                    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
                    svg.setAttribute('class', 'h-24 w-24 mx-auto text-blue-600');
                    svg.setAttribute('fill', 'currentColor');
                    svg.setAttribute('viewBox', '0 0 20 20');
                    svg.innerHTML = '<path fill-rule="evenodd" d="M6.267 3.455a3.066 3.066 0 001.745-.723 3.066 3.066 0 013.976 0 3.066 3.066 0 001.745.723 3.066 3.066 0 012.812 2.812c.051.643.304 1.254.723 1.745a3.066 3.066 0 010 3.976 3.066 3.066 0 00-.723 1.745 3.066 3.066 0 01-2.812 2.812 3.066 3.066 0 00-1.745.723 3.066 3.066 0 01-3.976 0 3.066 3.066 0 00-1.745-.723 3.066 3.066 0 01-2.812-2.812 3.066 3.066 0 00-.723-1.745 3.066 3.066 0 010-3.976 3.066 3.066 0 00.723-1.745 3.066 3.066 0 012.812-2.812zm7.44 5.252a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd" />';
                    parent.appendChild(svg);
                  }
                }}
              />
            </div>
          </div>
          
          {/* Certificate Image (Full certificate) */}
          <div className="flex justify-center mb-4">
            <img 
              src="/amfi-certificate.png" 
              alt="AMFI Registered Mutual Fund Distributor Certificate" 
              className="max-w-full h-auto max-h-64 object-contain rounded-lg shadow-md border border-gray-200"
              onError={(e) => {
                // Hide if certificate image not available
                const target = e.currentTarget as HTMLImageElement;
                target.style.display = 'none';
              }}
            />
          </div>
          
          <div className="mt-4">
            <h3 className="text-xl font-bold text-gray-900 mb-2">AMFI Registered</h3>
            <p className="text-gray-600 text-sm mb-3">
              Association of Mutual Funds in India - Registered Mutual Fund Distributor
            </p>
            <div className="bg-blue-50 rounded-lg p-3 border border-blue-200">
              <p className="text-blue-900 font-bold">ARN No: 349565</p>
              <p className="text-blue-700 text-sm mt-1">Valid: 30 Dec 2025 to 25 Dec 2028</p>
            </div>
          </div>
        </div>

        {/* IRDA/IRDAI Information */}
        <div className="bg-white rounded-xl shadow-lg p-6 border-2 border-green-100 hover:border-green-300 transition-all">
          <div className="flex justify-center mb-6">
            <img 
              src="/IRDIA.png" 
              alt="IRDAI Logo" 
              className="h-32 w-32 object-contain"
              onError={(e) => {
                // Fallback to gradient circle with shield if logo not found
                const target = e.currentTarget as HTMLImageElement;
                target.style.display = 'none';
                const parent = target.parentElement;
                if (parent && !parent.querySelector('.fallback-icon')) {
                  const fallback = document.createElement('div');
                  fallback.className = 'w-32 h-32 bg-gradient-to-br from-green-400 to-blue-500 rounded-full flex items-center justify-center fallback-icon';
                  fallback.innerHTML = '<svg class="w-20 h-20 text-white" fill="currentColor" viewBox="0 0 20 20"><path fill-rule="evenodd" d="M2.166 4.999A11.954 11.954 0 0010 1.944 11.954 11.954 0 0017.834 5c.11.65.166 1.32.166 2.001 0 5.225-3.34 9.67-8 11.317C5.34 16.67 2 12.225 2 7c0-.682.057-1.35.166-2.001zm11.541 3.708a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd" /></svg>';
                  parent.appendChild(fallback);
                }
              }}
            />
          </div>
          <h3 className="text-xl font-bold text-gray-900 mb-3 text-center">
            Licensed Insurance Advisor
          </h3>
          <div className="bg-green-50 rounded-lg p-3 border border-green-200 mb-4 text-center">
            <p className="text-green-900 font-bold">IRDAI Registered</p>
            <p className="text-green-700 text-sm mt-1">Insurance Regulatory and Development Authority of India</p>
          </div>
          <ul className="space-y-3 text-gray-700">
            <li className="flex items-start">
              <svg className="w-5 h-5 text-green-600 mr-2 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
              </svg>
              <span className="text-sm">Authorized to sell Life & Health Insurance products</span>
            </li>
            <li className="flex items-start">
              <svg className="w-5 h-5 text-green-600 mr-2 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
              </svg>
              <span className="text-sm">20+ years of industry experience</span>
            </li>
            <li className="flex items-start">
              <svg className="w-5 h-5 text-green-600 mr-2 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
              </svg>
              <span className="text-sm">Partnered with 10+ reputed insurance companies</span>
            </li>
            <li className="flex items-start">
              <svg className="w-5 h-5 text-green-600 mr-2 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
              </svg>
              <span className="text-sm">Compliant with all regulatory requirements</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="mt-8 text-center">
        <div className="inline-block bg-white rounded-lg shadow-md px-6 py-4 border-l-4 border-blue-600">
          <p className="text-gray-700">
            <span className="font-semibold text-gray-900">Trusted by 1000+ families</span> for their insurance and investment needs
          </p>
        </div>
      </div>
    </div>
  );
}
